import React, { Fragment } from "react";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../tailwind.config.js";
import { formatValue } from "../../components/Utils.js";
import AggregatedTable from "../../components/AggregatedTable.jsx";
import { SparkBar } from "../../components/chart-components/SparkBar.jsx";
const colors = resolveConfig(tailwindConfig).theme.colors;

const UntaggedOverviewTable = (props) => {
	const data = props.data;
	const sortTable = props.sortTable;
	const sortColumn = props.sortColumn;
	const addMoreCostDetails = props.addMoreCostDetails;
	const limit = props.limit;

	const calculatePercentage = (value, total, decimals = 2) => {
		if (total === 0) return 0;
		return ((value / total) * 100).toFixed(decimals);
	};


	const getClassNamesMeasures = (row) => {
		let classNames = "";

		if (row.row.original.cost_component) {
			classNames = "text-left text-text font-xs font-regular pl-2";
		} else {
			classNames = "text-left text-text font-semibold pl-2";
		}

		return classNames;
	}


	const columnDefs = [
		{
			accessor: "tag_key",
			id: "expander",
			Header: (row) => <div className=""><span data-tooltip-id="instantTooltip" data-tooltip-content="The tag that has not been applied to the resource">Tag</span></div>,
			Cell: ( row ) => {
                return (
                    <div className="pl-4 text-sm">
                        {row.value}
                    </div>
                )
			},
			minWidth: 300,
			width: 300,
			maxWidth: 300,
		},
		{
			accessor: "perc_untagged_cost",
			Header: (row) => (
				<div
					className="cursor-default"
				>
					<span data-tooltip-id="instantTooltip" data-tooltip-content="The percentage of the total cost that has not been tagged with this specific tag">Untagged cost</span>
				</div>
			),
			Cell: (cell) => (
				<div className={getClassNamesMeasures(cell)}>
					<SparkBar 
						data={calculatePercentage(cell.row.original.untagged_cost,cell.row.original.total_cost)} 
						barColor={cell.row.depth === 0 ? colors.red9 : cell.row.depth === 1 ? colors.red9 : colors.coolgrey8}
						maxValue={100}
						totalValue={100}
						format="percentage"
						decimals={1}
					/>
				</div>
			),
			width: 100,
		},
        {
			accessor: "untagged_cost",
			Header: (row) => (
				<div
					className="cursor-default"
				>
					<span data-tooltip-id="instantTooltip" data-tooltip-content="The cost of the resource that has not been tagged with this specific tag">Untagged cost</span>
				</div>
			),
			Cell: (row) => (
				<div className={getClassNamesMeasures(row)}>
					{formatValue(row.value, "currency", false)}
				</div>
			),
			width: 100,
		},
        // {
		// 	accessor: "untagged_resources",
		// 	Header: (row) => (
		// 		<div
		// 			className="cursor-default"
		// 		>
		// 			<span data-tooltip-id="instantTooltip" data-tooltip-content="The number of resources that have not been tagged">Untagged resources</span>
		// 		</div>
		// 	),
		// 	Cell: (row) => (
		// 		<div className="text-left text-coolgrey1 font-semibold pl-2">
		// 			{formatValue(row.value, "decimal", false)}
		// 		</div>
		// 	),
		// 	width: 100,
		// },
		// {
		// 	accessor: "perc_untagged_resources",
		// 	Header: (row) => (
		// 		<div
		// 			className="cursor-default"
		// 		>
		// 			<span data-tooltip-id="instantTooltip" data-tooltip-content="The percentage of the total number of resources that have not been tagged">Untagged resources</span>
		// 		</div>
		// 	),
		// 	Cell: (cell) => (
		// 		<div className={getClassNamesMeasures(cell)}>
		// 			<SparkBar 
		// 				data={calculatePercentage(cell.row.original.untagged_resources,cell.row.original.total_resources)} 
		// 				barColor={cell.row.depth == 0 ? colors.red10 : cell.row.depth == 1 ? colors.red9 : colors.coolgrey8}
		// 				maxValue={100}
		// 				totalValue={100}
		// 				format="percentage"
		// 				decimals={1}
		// 			/>
		// 		</div>
		// 	),
		// 	width: 100,
		// },        
		// {
		// 	accessor: "total_cost",
		// 	Header: (row) => (
		// 		<div
		// 			className="cursor-pointer"
		// 		>
		// 			Total cost
		// 		</div>
		// 	),
		// 	Cell: (row) => (
		// 		<div className={getClassNamesMeasures(row)}>
		// 			{formatValue(row.value, "currency", false)}
		// 		</div>
		// 	),
		// 	width: 100,
		// },
	];

	return (
		<Fragment>
			<AggregatedTable
				data={data}
				expandAll={true}
				sortColumn={sortColumn}
				sortTable={sortTable}
				retrieveData={addMoreCostDetails}
				limit={limit}
				columnDefs={columnDefs}
			/>
		</Fragment>
	);
};

export default UntaggedOverviewTable;
